<template>
  <v-card class="rounded-lg">
    <v-data-table
      :headers="headers"
      :items="projects"
      sort-by="position"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Projects list</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="700px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">New Project</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.alias"
                        label="Project alias"
                        filled
                        v-validate="{
                          required: true
                        }"
                        name="alias"
                        :error-messages="errors.collect('alias')"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.short_name"
                        label="Project short name"
                        filled
                        v-validate="{
                          required: true
                        }"
                        name="short_name"
                        :error-messages="errors.collect('short_name')"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="editedItem.active"
                        label="Project active"
                        filled
                        v-validate="{
                          required: true
                        }"
                        name="active"
                        :error-messages="errors.collect('active')"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.active="{ item }">
        {{ (item.active ? 'yes' : 'no') }}
      </template>
      <template v-slot:item.can_be_edited="{ item }">
        {{ (item.can_be_edited ? 'yes' : 'no') }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon
          v-if="item.can_be_edited"
          small
          class="mr-2"
          @click="editItem(item)"
        >
          {{ mdiPencil }}
        </v-icon>
      </template>
    </v-data-table>
    <delete-dialog
      v-if="deleteDialog"
      :item="deletedItem"
      @close="deleteDialog = false"
      @confirm="deleteItem"
    />
  </v-card>
</template>

<script>
import { mdiPencil } from "@mdi/js"
export default {
  components: {
    deleteDialog: () => import('@/components/dialogs/DeleteDialog.vue'),
  },
  data: () => ({
    mdiPencil,
    dialog: false,
    deleteDialog: false,
    headers: [
      {
        text: 'Name',
        value: 'alias',
        sortable: false,
      },
      {
        text: 'Short name',
        value: 'short_name',
        sortable: false,
      },
      {
        text: 'Active',
        value: 'active',
        sortable: false,
      },
      {
        text: 'Can be edited?',
        value: 'can_be_edited',
        sortable: false,
      },
      {
        text: 'Actions',
        value: 'action',
        sortable: false,
      },
    ],
    projects: [],
    editedIndex: -1,
    editedItem: {
      short_name: '',
      alias: '',
      active: true,
      can_be_edited: true
    },
    defaultItem: {
      short_name: '',
      alias: '',
      active: true,
      can_be_edited: true
    },
    deletedItem: null
  }),
  created() {
    this.$axios.get('/api/global/projects')
    .then(payload => {
      this.projects = payload.data;
    })
    .catch(err => {
      console.log(err)
    })
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Project' : 'Edit Project';
    },
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.projects.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      try {
        let { data } = await this.$axios.delete('/api/global/projects/' + item.id);
        this.projects = data.sort((a,b) => a.position - b.position);
      } catch (err) {
        console.log(err.message);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save() {
      this.$validator.validateAll().then(async res => {
        if (res) {
          try {
            if (this.editedIndex > -1) {
              let { data } = await this.$axios.put('/api/global/projects/' + this.editedItem.id, this.editedItem);
              this.$set(this.projects, this.editedIndex, data);
            } else {
              let { data } = await this.$axios.post('/api/global/projects/', this.editedItem);
              this.projects.push(data);
            }
          } catch(err) {
            console.log(err.message);
          }
          this.close();
        }
      })
    },
  },
}
</script>
